<template>
  <div class="">
    <div>
      <div class="title">
        <gl-sub-text>相手</gl-sub-text>
      </div>
      <md-radio v-model="_compare" value="item">
        単品
      </md-radio>
      <md-radio v-model="_compare" value="category">
        カテゴリ
      </md-radio>
    </div>
    <div>
      <div class="title">
        <gl-sub-text>ソート順</gl-sub-text>
      </div>
      <md-radio v-model="_sort" value="compare">
        逆引き(相手本位)
      </md-radio>
      <md-radio v-model="_sort" value="base">
        順引き(自分本位)
      </md-radio>
    </div>
    <div>
      <gl-switch v-model="_expect">合計政策ボリュームが期待できる</gl-switch>
    </div>
  </div>
</template>

<script>
import ErrorReport from '@/mixins/ErrorReport'

export default {
  mixins: [ErrorReport],
  props: {
    compare: {
      type: String,
      default: 'item',
    },
    sort: {
      type: String,
      default: 'compare',
    },
    expect: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _compare: {
      get() {
        return this.compare
      },
      set(newVal) {
        this.$emit('update:compare', newVal)
      },
    },
    _sort: {
      get() {
        return this.sort
      },
      set(newVal) {
        this.$emit('update:sort', newVal)
      },
    },

    _expect: {
      get() {
        return this.expect
      },
      set(newVal) {
        this.$emit('update:expect', newVal)
      },
    },
    errors() {
      const errors = []
      return errors
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: var(--spacing-medium);
}
</style>
